
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/directors-parlor/3",
      function () {
        return require("private-next-pages/directors-parlor/3.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/directors-parlor/3"])
      });
    }
  